export default __webpack_public_path__ + "static/Plots0005-3e068d96d51bcdb29a2755b0402e231d.jpg";